import { useCallback, useRef, useState } from 'react'
import { createContainer } from 'unstated-next'

import { EmbroideryService } from './EmbroideryService'
import { useEmbroideryConfirmation } from './useEmbroideryConfirmation'

export interface UseEmbroideryModalProps {
  onOpenEmbroideryModal?: () => void
  isPortalColorSelected?: boolean
}

export function useEmbroideryModal({
  onOpenEmbroideryModal,
  isPortalColorSelected = false,
}: UseEmbroideryModalProps | undefined = {}) {
  const { setSelectedFormKind, selectedEmbroideryFormOptions } = EmbroideryService.useContainer()
  const [shouldDisplayEmbroideryModal, setShouldDisplayEmbroideryModal] = useState<boolean>(false)
  const { setConfirmAddEmbroidery } = EmbroideryService.useContainer()
  const editEmbroideryRef = useRef<HTMLButtonElement>(null)

  const openEmbroideryModal = useCallback(() => {
    setShouldDisplayEmbroideryModal(true)
    onOpenEmbroideryModal && onOpenEmbroideryModal()
  }, [onOpenEmbroideryModal])

  const closeEmbroideryModal = useCallback(() => {
    setSelectedFormKind(null)
    setShouldDisplayEmbroideryModal(false)
  }, [setSelectedFormKind, setShouldDisplayEmbroideryModal])

  const onAfterEmbroideryModalClose = useCallback(() => {
    if (selectedEmbroideryFormOptions && editEmbroideryRef.current) {
      editEmbroideryRef.current?.focus()
    }
  }, [editEmbroideryRef, selectedEmbroideryFormOptions])

  const { handleConfirm, formErrors } = useEmbroideryConfirmation({
    withPortalValidation: isPortalColorSelected,
    onSubmit: () => {
      setConfirmAddEmbroidery(true)
      closeEmbroideryModal()
    },
  })

  return {
    editEmbroideryRef,
    closeEmbroideryModal,
    openEmbroideryModal,
    onAfterEmbroideryModalClose,
    shouldDisplayEmbroideryModal,
    isPortalColorSelected,
    handleConfirm,
    formErrors,
  }
}

export const EmbroideryModalService = createContainer(useEmbroideryModal)
